export default "__VITE_ASSET__CNYDOECt__"